export default "__VITE_ASSET__CKCYUiXe__"